declare global {
  interface Window {
    EbizioEventManager: {
      pageType: string;
      checkoutId: string;
    };
  }
}

import type { EbizioEventConfig, EbizioOrderEventConfig } from './types';
import { CHECKOUT_CONTAINER } from './constants';
import {
  billingStepLoadingConfig,
  cartSummaryDesktopMountedConfig,
  cartSummaryMobileMountedConfig,
  cartSummaryModalOpenedConfig,
  checkoutLoadedConfig,
  couponsChangeddConfig,
  customerSignedInConfig,
  customerSignedOutConfig,
  customerStepLoadingConfig,
  giftCertificatesChangedConfig,
  orderConfirmationLoadedConfig,
  paymentMethodLoadedConfig,
  paymentMethodSelectedConfig,
  paymentStepLoadingConfig,
  paymentStepSubmittedConfig,
  savedShippingAddressChangedConfig,
  shippingMethodSelectedConfig,
  shippingStepLoadingConfig,
  shippingStepSubmittedConfig,
  storeCreditToggledConfig,
  useNewShippingAddressSelectedConfig,
} from './events';

import './custom/styles';

/**
 * Configuration
 */
export const ebizioEventConfig: (EbizioEventConfig | EbizioOrderEventConfig)[] =
  [
    // global
    checkoutLoadedConfig,
    couponsChangeddConfig,
    giftCertificatesChangedConfig,
    cartSummaryDesktopMountedConfig,
    cartSummaryMobileMountedConfig,
    cartSummaryModalOpenedConfig,
    // // customer step
    customerSignedInConfig,
    customerSignedOutConfig,
    customerStepLoadingConfig,
    // shipping step
    shippingStepLoadingConfig,
    shippingStepSubmittedConfig,
    shippingMethodSelectedConfig,
    savedShippingAddressChangedConfig,
    useNewShippingAddressSelectedConfig,
    // billing step
    billingStepLoadingConfig,
    // payment step
    paymentStepLoadingConfig,
    paymentStepSubmittedConfig,
    paymentMethodSelectedConfig,
    paymentMethodLoadedConfig,
    storeCreditToggledConfig,
    // order confirmation
    orderConfirmationLoadedConfig,
  ];

/**
 * Setup Listeners
 */
ebizioEventConfig.forEach((config) => {
  if (CHECKOUT_CONTAINER) {
    CHECKOUT_CONTAINER.addEventListener(
      config.event,
      config.handler as EventListener,
    );
  }
});
